import { useState } from "react"
import { usePageAssets } from "hooks/usePageAssets"
import ContactSalesModal from "components/ContactSalesModal"
import { openModal } from "utils/openModal"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import CTA from "components/ui/CTA"

function SingleCTASection() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const { getAsset } = usePageAssets()
  const background = getAsset("single-cta-preset-background")
  return (
    <Container section>
      <CTA
        background={background}
        label="Get in Touch"
        title="Deploy Preset inside your private cloud."
        size="wide"
        dark
      >
        <Button
          className="mt-5"
          color="catskill-white"
          size="medium"
          href="/contact-sales/"
          onClick={openModal(setIsContactModalOpen)}
          trackClick="Contact Sales (cta)_Preset Managed Private Cloud"
        >
          Talk to an Expert
        </Button>
      </CTA>
      <ContactSalesModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        sourcePage="MPC - CTA"
      />
    </Container>
  )
}

export default SingleCTASection
